@use "variables" as *;

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.datePicker {
  width: 100%;
}
